$(document).ready(function() {
    

    $('.switch-guest-view').click(function(e){
    	e.preventDefault();

    	var showGrid = true;

    	if($('#guests-grid-view').is(":visible")){
    		showGrid = false;
    	}

    	$('.guest-view').hide();

    	if(showGrid){
    		$('#guests-grid-view').show();
    		$('.switch-guest-view').text('Table View');
    	}else{
    		$('#guests-table-view').show();
            $('.switch-guest-view').text('Card View');
        }

    });


    $('.go-back-btn').click(function() {
		window.history.back();
	});

    var datatableSelectSelector = '.dataTables_length label select';
    var datatableSearchSelector = '.search-container input';

    $(document).on("change", datatableSearchSelector, function() {
       setLocationHash($(this).val(),'qry');
    });

    $(document).on("change", datatableSelectSelector, function() {
        setLocationHash($(this).val(),'limit');
    });

    function setLocationHash(val,varName){

        var existingHash = document.location.hash;

        if(existingHash.includes("?")){
            document.location.hash += "&"+ varName +"=" + val;
        }else{
            document.location.hash = "?"+ varName +"=" + val;
        }

    }

    // function setDatatablesSearch(val){
    //     $(datatableSearchSelector).val(val).trigger('click');
    // }

    // function setDatatablesSelect(val){
    //     $(datatableSelectSelector).val(val);
    // }

   

} );


// WEBPACK FOOTER //
// ./global.js